export default __webpack_public_path__ + "static/media/Golden-Snitch-Rigged-01.12c730ec.jpg";